import PropTypes from 'prop-types';
import React, { Component } from 'react';
import formValueSelector from 'redux-form/es/formValueSelector';
import { connect } from 'react-redux';
import { getLoanPurposes } from 'actions/loan';
import Spinner from 'components/Credit24/Core/Spinner';
import LoanPurpose from 'components/Credit24/LoanApplication/LoanPurposeAU';

const propTypes = {
  loan: PropTypes.object.isRequired,
  getLoanPurposes: PropTypes.func.isRequired,
  loanPurposes: PropTypes.array.isRequired,
};

class LoanPurposeAUContainer extends Component {
  constructor() {
    super();
    this.state = {
      selectedPurposes: {},
    };
    this.onLoanPurposeChange = this.onLoanPurposeChange.bind(this);
    this.restoreSelectedLoanPurposes = this.restoreSelectedLoanPurposes.bind(this);
    this.validate = this.validate.bind(this);
  }

  componentDidMount() {
    if (this.props.loan.loanPurposes) {
      this.restoreSelectedLoanPurposes();
    } else {
      this.props.getLoanPurposes();
    }
  }

  onLoanPurposeChange(event, newValue) {
    this.setState((prevState) => {
      const purposes = { ...prevState.selectedPurposes };
      if (newValue) {
        const { target } = event;
        purposes[target.name] = target.value;
      } else {
        delete purposes[event.target.name];
      }
      return { selectedPurposes: purposes };
    });
  }

  restoreSelectedLoanPurposes() {
    const selectedPurposes = {};
    Object.keys(this.props.loanPurposes).forEach((loanPurposeId) => {
      const matchingLoanPurposeById = this.props.loan.loanPurposeSuggestions.find((item) =>
        item.id === parseInt(loanPurposeId, 10) && this.props.loanPurposes[item.id] === true);
      if (matchingLoanPurposeById) {
        selectedPurposes[`loanPurposes.${loanPurposeId}`] = matchingLoanPurposeById.fullText;
      }
    });
    if (Object.keys(selectedPurposes).length > 0) {
      this.setState({
        selectedPurposes,
      });
    }
  }

  validate() {
    return Object.keys(this.state.selectedPurposes).length === 0;
  }

  render() {
    const { loan } = this.props;
    const { loanPurposes } = loan;
    if (loan.isContentLoading || !loanPurposes) {
      return (
        <div className="loan-form__step loan-form__step--loading">
          <Spinner />
        </div>
      );
    }

    return (
      <LoanPurpose
        purposes={loanPurposes}
        selectedPurposes={this.state.selectedPurposes}
        validate={this.validate}
        onLoanPurposeChange={this.onLoanPurposeChange}
      />
    );
  }
}

LoanPurposeAUContainer.propTypes = propTypes;

const selector = formValueSelector('loan');

export default connect(
  (state) => ({
    loan: state.loan,
    loanPurposes: selector(state, 'loanPurposes') || [],
  }),
  { getLoanPurposes }
)(LoanPurposeAUContainer);
